import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableContainerProps,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import HelpButton from "../HelpButton";
import SimpleParagraphs from "./commons/SimpleParagraphs";

function CaffeineTableContainer(props: TableContainerProps) {
  return (
    <TableContainer
      sx={{
        borderRadius: 0,
        border: "1px solid #e0e0e0",
        "& .MuiTableCell-root": {
          borderBottom: "none",
        },
        "& .MuiTableCell-head": {
          px: 0,
          py: 4,
          color: "#3d3d3d",
          "&>.MuiTypography-root": {
            px: 4,
          },
          "&:not(:first-of-type)>.MuiTypography-root": {
            borderLeft: "1px solid #e0e0e0",
          },
        },
        "& .MuiTableCell-body": {
          color: "3d3d3d",
          borderTop: "1px solid #e0e0e0",
          "&:not(:first-of-type)": {
            borderLeft: "1px solid #e0e0e0",
          },
        },
      }}
      {...props}
    />
  );
}

function TableSections({
  contents,
}: {
  contents: {
    title: string;
    table: {
      head: string[];
      body: string[][];
    };
  }[];
}) {
  return (
    <>
      {contents.map((c, i) => (
        <Stack gap={2} key={i}>
          <Typography variant="subtitle2" fontSize="16px">
            {c.title}
          </Typography>
          <CaffeineTableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {c.table.head.map((h, j) => (
                    <TableCell key={j}>
                      <Typography variant="subtitle2">{h}</Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {c.table.body.map((r, j) => (
                  <TableRow key={j}>
                    {r.map((d, k) => (
                      <TableCell key={`${j}-${k}`}>
                        <Typography variant="body2">{d}</Typography>
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CaffeineTableContainer>
        </Stack>
      ))}
    </>
  );
}

export default function CaffeineHelpDialog() {
  return (
    <HelpButton dialogTitle="カフェイン">
      <Stack sx={{ gap: 6 }}>
        <SimpleParagraphs
          paragraphs={[
            {
              title: "睡眠への影響",
              content:
                "カフェインには覚醒作用があり、スムーズな入眠を妨げます。利尿作用もあるため、途中でトイレに起きたりすることにつながります。",
            },
            {
              title: "おすすめ",
              content:
                "個人差がありますがカフェインの半減期は3～5時間程度のため、夜はカフェインが含まれていない飲料をとるようにしましょう。",
            },
          ]}
        />
        <TableSections
          contents={[
            {
              title: "カフェインが少ない／含まれないもの",
              table: {
                head: ["飲み物・食べ物の種類"],
                body: [
                  [
                    "麦茶、昆布茶、ごぼう茶、そば茶、はと麦茶、コーン茶、黒豆茶、たんぽぽ茶、デカフェ飲料、ルイボスティー、水、炭酸水、牛乳",
                  ],
                ],
              },
            },
            {
              title: "カフェインが多いもの",
              table: {
                head: ["飲み物・食べ物の種類", "カフェインの量（100mL中）"],
                body: [
                  ["コーヒー", "60mg"],
                  ["エナジードリンク", "32～300mg"],
                  ["紅茶", "30mg"],
                  ["玉露", "160mg"],
                  ["緑茶・ほうじ茶・ウーロン茶・ジャスミン茶", "20mg"],
                  ["玄米茶", "10mg"],
                  ["コーラ", "10mg"],
                  ["ココア", "14mg"],
                  ["チョコレート", "7～21mg／25gあたり"],
                ],
              },
            },
          ]}
        />
      </Stack>
    </HelpButton>
  );
}
